/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTagDto } from '../models/CreateTagDto';
import type { UpdateTagDto } from '../models/UpdateTagDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TagsService {
  /**
   * Create a new tag
   * @param requestBody
   * @returns any Tag created successfully
   * @throws ApiError
   */
  public static tagsControllerCreate(requestBody: CreateTagDto): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/tags',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        409: `Tag name already exists`,
      },
    });
  }
  /**
   * Get all tags
   * @param page Page number
   * @param limit Items per page
   * @param search Search by tag name
   * @returns any Returns all tags
   * @throws ApiError
   */
  public static tagsControllerFindAll(
    page?: number,
    limit?: number,
    search?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/tags',
      query: {
        page: page,
        limit: limit,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Get a tag by ID
   * @param id
   * @returns any Returns the tag
   * @throws ApiError
   */
  public static tagsControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/tags/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Tag not found`,
      },
    });
  }
  /**
   * Update a tag
   * @param id
   * @param requestBody
   * @returns any Tag updated successfully
   * @throws ApiError
   */
  public static tagsControllerUpdate(
    id: string,
    requestBody: UpdateTagDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/tags/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Tag not found`,
        409: `Tag name already exists`,
      },
    });
  }
  /**
   * Delete a tag
   * @param id
   * @returns any Tag deleted successfully
   * @throws ApiError
   */
  public static tagsControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/tags/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Cannot delete tag - it is being used by products`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Tag not found`,
      },
    });
  }
}
